import { NumberHelper } from "./number.helper";
import * as moment from "moment";
import { autoinject } from "aurelia-dependency-injection";
import { ConfigService } from '../services/basic/config.service';

@autoinject()
export class DateTimeHelper {

    constructor(configService: ConfigService) {
        this.constructor.prototype.publicConfigService = configService;
    }

    public static getUtcNow(): string {
        const now: Date = new Date();
        return now.toJSON();
    }

    public static getTodayNoDate(): Date {
        return new Date((this.getDateString(new Date())));
    }

    public static getUtcNowOffsetted(): string {
        const now: Date = new Date();
        return new Date(now.getTime() + now.getTimezoneOffset() * 60000).toJSON();
    }

    public static getDateOffsetted(date: Date): string {
        return new Date(date.getTime() + (date.getTimezoneOffset() + ((<any>moment(date)).isDST() ? 60 : 0)) * 60000).toJSON()
    }

    public static getDateString(date: Date | string): string {
        let dateFromString: Date;
        if (typeof date === "string") {
            dateFromString = new Date(date);
        }
        const dateValue: Date = typeof date === "string" ? dateFromString : date;
        return dateValue.getFullYear() +
            "-" +
            (NumberHelper.pad2(dateValue.getMonth() + 1)) +
            "-" +
            NumberHelper.pad2(dateValue.getDate());
    }

    public static getDateFormatted(value: any, format: string = this.constructor.prototype.publicConfigService.config.common.defaultDateTimeFormat): string {
        return moment(new Date(value)).format(format);
    }

    public static getFormattedDate(date: Date): string {
        const dateStr = NumberHelper.pad2(date.getDate()) + "/" +
            (NumberHelper.pad2(date.getMonth() + 1)) +
            "/" + date.getFullYear();
        return dateStr;
    }

    public static castDate(value: Date | string): Date {
        if (value && (moment.isMoment(value))) {
            return value.toDate();
        }
        return typeof value === "string" ? new Date(value) : <Date>value;
    }

    public static isInvalidDate(d: Date): boolean {
        if (Object.prototype.toString.call(d) === "[object Date]") {
            // it is a date
            if (isNaN(d.getTime())) {  // d.valueOf() could also work
                // date is not valid
                return true;
            }
            else {
                // date is valid
                return false;
            }
        }
        else {
            // not a date
            return true;
        }
    }

    public static daysBetweenDates(firstDate: string, secondDate: string): number {
        const firstDateObj = new Date(firstDate);
        const secondDateObj = new Date(secondDate);
        const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
        const timeDifference = Math.abs(secondDateObj.getTime() - firstDateObj.getTime());
        const daysDifference = Math.floor(timeDifference / oneDayInMilliseconds);
        return daysDifference;
    }
}
